import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import './Nav-Slide.css';

import bg1 from '../../assets/container.jpg';
import bg2 from '../../assets/trucks transporting .jpg';
import bg3 from '../../assets/transport-logistics-concept.jpg'; // Add as many as needed
import human from '../../assets/african-american-worker-her-coworker-reading-order-list-before-shipment-while-working-warehouse.jpg'

const images = [bg1, bg2, bg3];

const NavSlide = () => {
  const [current, setCurrent] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000); // 5 sec per slide
    return () => clearInterval(interval);
  }, []);


  return (
    <div className="nav-slide">
      <div className="hero-section">
        <div className="background-fader">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="background"
              className={`bg-image ${index === current ? 'active' : ''}`}
            />
          ))}
        </div>
        <Navbar />
        <div className="hero-content">
          <div className='hero-left'>
            <p className="sub-heading">WE ARE BEST LOGISTIC COMPANY</p>
            <h1 className="main-heading">
              STREAMLINE YOUR SHIPPING WITH <br /> OUR CARGO SERVICES
            </h1>
            <p className="description">
              Simplify your shipping process and make it more efficient with our cargo services.
              From start to finish, we’ll handle everything to ensure your cargo arrives safely.
            </p>

            <div className="stats">
              <div className="stat-item1">
                <img src={human} alt="client" className='human' />
                <div className='clientNo'>
                  <h2>26 K</h2>
                  <p>Satisfied Clients</p>
                </div>
              </div>
              <p className='line'></p>
              <div className="stat-item2">
                <h2>12 +</h2>
                <p>Years of Experience</p>
              </div>
            </div>
          </div>
          {/* <div className="tracking-card">
            <div className="tabs">
              <span className="tab active">TRACKING</span>
              <span className="tab">RATE & SHIP</span>
            </div>
            <div className="track-form">
              <input type="text" placeholder="TRACKING ID" />
              <button>TRACK</button>
            </div>
            <p className="help-text">
              See the tracking ID on shipping document. <span>Help</span>
            </p>
          </div> */}
        </div>
        <div className="slide-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === current ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default NavSlide;
